<template>
  <div class="checkout">
    <div class="mt-base">
      <!-- <vs-breadcrumb :items="items" class="mb-6"></vs-breadcrumb> -->
      <div class="flex md:flex-row flex-col md:justify-between md:align-center">
        <!-- <vs-checkbox class="text-primary m-0" v-model="new_ver">Use new version</vs-checkbox> -->
        <div class="vx-breadcrumb mt-1 ml-4">
          <ul class="flex flex-wrap items-center">
            <li class="inline-flex items-end">
              <router-link to="/after-login">
                <feather-icon
                  icon="HomeIcon"
                  svgClasses="h-5 w-5 mb-1 mr-1 stroke-current text-primary"
                />
              </router-link>
              <span class="breadcrumb-separator mx-2 mr-1">
                <feather-icon icon="ChevronsRightIcon" svgClasses="w-4 h-4" />
              </span>
            </li>
            <li class="inline-flex items-end">
              <span class="breadcrumb-separator mx-2 mb-1 cur-breadcrumb-color">Checkout</span>
            </li>
          </ul>
        </div>
        <div class="flex flex-wrap-reverse items-center flex-grow justify-end">
          <div class="sm:flex flex-wrap my-head-action">
            <vs-dropdown
              vs-trigger-click
              class="cursor-pointer item-per-page-dropdown mr-4"
              style="width: 100px"
            >
              <div
                class="py-2 px-4 border border-solid d-theme-border-grey-light rounded-item d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
              >
                <span class="mr-2">{{sort_by.title}}</span>
                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
              </div>
              <vs-dropdown-menu style="width:120px">
                <vs-dropdown-item
                  v-for="(item, i) in sortByOptions"
                  :key="i"
                  v-model="sort_by"
                  @click="sortBy(item)"
                >
                  <span
                    class="w-full flex justify-between"
                    :class="{'text-primary': sort_by.id == item.id}"
                  >
                    {{item.title}}
                    <feather-icon
                      icon="CheckIcon"
                      svgClasses="h-3 w-3 ml-2"
                      v-if="sort_by.id == item.id"
                    />
                  </span>
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>

            <vs-dropdown
              vs-trigger-click
              class="cursor-pointer item-per-page-dropdown mr-4"
              style="width: 100px"
            >
              <div
                class="py-2 px-4 border border-solid d-theme-border-grey-light rounded-item d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
              >
                <span class="mr-2">{{filter.title}}</span>
                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
              </div>
              <vs-dropdown-menu style="width:120px">
                <vs-dropdown-item
                  v-for="(item, i) in filterOptions"
                  :key="i"
                  v-model="filter"
                  @click="filterType(item)"
                >
                  <span
                    class="w-full flex justify-between"
                    :class="{'text-primary': filter.id == item.id}"
                  >
                    {{item.title}}
                    <feather-icon
                      icon="CheckIcon"
                      svgClasses="h-3 w-3 ml-2"
                      v-if="filter.id == item.id"
                    />
                  </span>
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
            <div class="con-input-search vs-table--search mr-4">
              <input
                type="text"
                class="input-search vs-table--search-input border-custom"
                v-model="search"
                @keyup="searchCustomer"
                placeholder="Name, phone"
                style="height: 38px; border-radius: 8px; font-size: 12px;"
              />
              <i class="vs-icon notranslate icon-scale material-icons null">search</i>
            </div>
            <div class="grid-list-transfer">
              <feather-icon
                icon="GridIcon"
                @click="currentItemView='checkout-grid'"
                class="p-2 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer"
                :svgClasses="{'text-primary stroke-current': currentItemView == 'checkout-grid'}"
              />
              <feather-icon
                icon="ListIcon"
                @click="currentItemView='checkout-list'"
                class="p-2 ml-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer sm:inline-flex"
                :svgClasses="{'text-primary stroke-current': currentItemView == 'checkout-list'}"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div class="mt-4">
        <template v-if="currentItemView == 'checkout-list'">
          <vs-checkout-list
            :new_ver="new_ver"
            :search="search"
            :filter="filter"
            :sort_by="sort_by"
            @ChangeView="changeView"
          ></vs-checkout-list>
        </template>
        <template v-if="currentItemView == 'checkout-grid'">
          <vs-checkout-grid
            :new_ver="new_ver"
            :search="search"
            :filter="filter"
            :sort_by="sort_by"
            @ChangeView="changeView"
          ></vs-checkout-grid>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import { EventSourcePolyfill } from "event-source-polyfill";
import { domain, client_id } from "../axios";
import * as md5 from "md5";

export default {
  components: {
    ItemCheckin: () => import("../components/checkout/ItemCheckin.vue"),
    PopupInfo: () => import("../components/checkout/PopupInfo.vue")
  },
  props: {
    dataChange: {
      type: Object
    }
  },
  created() {
    this.subscribeTopic();
    const lastRecord = () => {
      this.$store.dispatch("checkin/CHECK_UPDATE").then(isUpdated => {
        if (isUpdated) {
          const obj = {
            keyword: this.search
          };
          if (this.filter.id != 1) {
            obj.type = this.filter.name;
          }
          if(this.sort_by.id == 2) {
            obj.sort = this.sort_by.name;
          }
          this.$store.dispatch("checkin/GET_CHECKIN_LIST", obj);
        }
      });
    };
    lastRecord();
    this.interval = setInterval(lastRecord, 10000);
  },
  destroyed() {
    clearInterval(this.interval);
    this.eventSource.close();
  },
  data() {
    return {
      new_ver: true,
      // currentPage: 1,
      // totalPage: 20,
      currentItemView: "checkout-list",
      // itemsPerPage: 3,
      // check_in_data: [],
      items: [
        {
          title: "Home",
          url: "/"
        },
        {
          title: "Checkout",
          active: true
        }
      ],
      search: "",
      filterOptions: [
        { id: 1, title: "All", name: "all" },
        { id: 2, title: "New", name: "new" },
        { id: 3, title: "At risk", name: "atrisk" },
        { id: 4, title: "Vip", name: "vip" },
        { id: 5, title: "Regular", name: "regular" },
        { id: 6, title: "Normal", name: "normal" }
      ],
      filter: { id: 1, title: "All", name: "all" },

      sortByOptions: [
        { id: 1, title: "Latest", name: "-create_at" },
        { id: 2, title: "Oldest", name: "create_at" }
      ],
      sort_by: { id: 1, title: "Latest", name: "-create_at" },

      interval: null
    };
  },
  watch: {
    dataChange: {
      immediate: true,
      deep: true,
      handler: function() {
        if (this.dataChange.message != "") {
          const obj = {
            // page: this.currentPage,
            // "per-page": this.itemsPerPage,
            keyword: this.search
          };
          if (this.filter.id != 1) {
            obj.type = this.filter.name;
          }
          if(this.sort_by.id == 2) {
            obj.sort = this.sort_by.name;
          }
          this.$store.dispatch("checkin/GET_CHECKIN_LIST", obj);
        }
      }
    }
  },
  methods: {
    searchCustomer({ target }) {
      this.search = target.value;
    },
    sortBy(type) {
      this.sort_by = type;
      // console.log(this.sort_by);

    },
    filterType(type) {
      this.filter = type;
      // const obj = {
      //   page: this.currentPage,
      //   "per-page": this.itemsPerPage,
      //   "keyword": this.search,
      //   type: this.filter.name
      // }
      // if(this.filter.id == 1) {
      //   delete obj.type
      // }
      // this.$store.dispatch('checkin/GET_CHECKIN_LIST', obj)
    },
    changeView() {
      this.filter = { id: 1, title: "All", name: "all" };
      this.sort_by = { id: 1, title: "Latest", name: "-create_at" };
      this.search = "";
    },
    getDomain() {
      let temp = domain;
      if (domain[domain.length - 1] == "/") {
        temp = domain.slice(0, -1);
      }
      return temp.substring(temp.lastIndexOf("/") + 1);
    },
    subscribeTopic() {
      let topic = "/v1/gocheckin/checkin";
      let topic2 = "/v1/gocheckin/checkout";
      let hubUrl = "";
      let jwt = "";
      if (process.env.NODE_ENV == "development") {
        hubUrl = process.env.VUE_APP_DEVELOPMENT_MERCURE_HUB_URL;
        jwt = process.env.VUE_APP_DEVELOPMENT_MERCURE_JWT;
      } else {
        let mercure = JSON.parse(localStorage.getItem("appMercure"));
        hubUrl = mercure.hub_url;
        jwt = mercure.jwt;
      }
      const option = {
        headers: {
          Authorization: "Bearer " + jwt
        }
      };
      let id = md5(client_id);

      const u = new URL(hubUrl);
      u.searchParams.append("topic", id + "/" + this.getDomain() + topic);
      u.searchParams.append("topic", id + "/" + this.getDomain() + topic2);
      this.eventSource = new EventSourcePolyfill(u, option);
      this.eventSource.onmessage = e => {
        this.dataChange.message = JSON.parse(e.data);
        this.dataChange.key++;
        // console.log(this.dataChange)
      };
    }
  }
  // methods: {

  //   f_totalPage(data) {
  //     this.totalPage = Math.ceil(data.length / this.itemsPerPage);
  //     return this.totalPage;
  //   },
  //   f_getData() {
  //       test_data.result.check_in.forEach((check_in) => {
  //       const temp = new CheckOut(check_in.check_in.id,
  //                   check_in.customer.name,
  //                   check_in.customer.created_at,
  //                   check_in.customer.last_visited,
  //                   check_in.customer.type,
  //                   check_in.customer.point,
  //                   check_in.staffs,
  //                   check_in.services,
  //                   check_in.groups,
  //                   check_in.check_out.status);
  //       this.check_in_data.push(temp);
  //       });
  //   }
  // },
  // created() {
  //     this.f_getData();
  //     this.f_totalPage(this.check_in_data);
  // }
  // computed: {
  //   checkinData() {
  //     return this.$store.getters['checkin/checkinList'];
  //   }
  // },
  // created() {
  //   const obj = {
  //       page: this.currentPage,
  //       "per-page": this.itemsPerPage,
  //       "keyword": this.search,
  //     }
  //   this.$store.dispatch('checkin/GET_CHECKIN_LIST', obj);
  // }
};
</script>